import React from 'react';

export function NewHDHealthcareWishes() {
  return (
    <div className="new-ha-healthcare-wishes">
      <h1>Healthcare Wishes</h1>
      <p>Document your specific healthcare preferences and end-of-life wishes.</p>
    </div>
  );
}